const translations = {
  PrivacyPolicy: 'Polityka Prywatności',
  BackToApplication: 'Wróć do aplikacji',
};

export default translations;
